import { useSelector } from "react-redux"
import { selectCollectionStatus } from "./model"
import { DataStatus } from "../enums"
import { Content } from "./schema"
import { RootState } from "../../reduxStore/store"

/**
 * Check if any of the specified CMS collections have failed to load.
 */
export const useCMSCollectionErrors = (
  collectionNames: (keyof Content)[],
): boolean => {
  return useSelector((state: RootState) =>
    collectionNames.some(
      (name) => selectCollectionStatus(name)(state) === DataStatus.ERROR,
    ),
  )
}

/**
 * Check if any of the specified CMS collections are currently loading.
 */
export const useCMSCollectionsLoading = (
  collectionNames: (keyof Content)[],
): boolean => {
  return useSelector((state: RootState) =>
    collectionNames.some(
      (name) => selectCollectionStatus(name)(state) === DataStatus.LOADING,
    ),
  )
}

/**
 * Check if any of the specified CMS collections are currently pending.
 */
export const useCMSCollectionsPending = (
  collectionNames: (keyof Content)[],
): boolean => {
  return useSelector((state: RootState) =>
    collectionNames.some(
      (name) => selectCollectionStatus(name)(state) === DataStatus.PENDING,
    ),
  )
}

/**
 * Check if all of the specified CMS collections have been successfully loaded.
 */
export const useCMSCollectionsLoaded = (
  collectionNames: (keyof Content)[],
): boolean => {
  return useSelector((state: RootState) =>
    collectionNames.every(
      (name) => selectCollectionStatus(name)(state) === DataStatus.LOADED,
    ),
  )
}
